/**
 *
 * MultiStepForm
 *
 */
import React, { useEffect } from 'react';

import { useMultistepForm } from 'hooks/useMultiStepForm';
import MultiStepFormHeader from './components/MultiStepFormHeader';

import { FormWrapper, Form } from './styles';
import * as LS from 'styles/__layout';

interface Props {
  name: string;
  steps: React.ReactElement[];
  withHeader?: boolean;
  hasCompletionStep?: boolean;
  saveToLocalStorage?: boolean;
  center?: boolean;
}

export const MultiStepForm = ({
  name,
  steps,
  withHeader = true,
  hasCompletionStep = false,
  saveToLocalStorage = false,
  center = true,
}: Props) => {
  /**
   * Forms
   */
  const {
    step,
    stepNames,
    currentStepStorageKey,
    currentStepIndex,
    isFirstStep,
    length: stepsLength,
    next,
    back,
    goTo,
    completeForm,
  } = useMultistepForm(name, steps, hasCompletionStep, saveToLocalStorage);

  /**
   * Lifecycle
   */
  useEffect(() => {
    const storedIndex = localStorage.getItem(currentStepStorageKey);
    if (storedIndex) {
      const index = parseInt(storedIndex, 10);
      goTo(index);
    }
  }, [currentStepStorageKey, goTo]);

  /**
   * Return
   */
  return (
    <>
      {withHeader && (
        <MultiStepFormHeader
          currentStepIndex={currentStepIndex}
          stepsLength={stepsLength}
          stepNames={stepNames}
          isFirstStep={isFirstStep}
          navigateBack={back}
        />
      )}
      <LS.Col alignItems={center ? 'center' : null} justifyContent={center ? 'center' : null}>
        <FormWrapper>
          <Form>{React.cloneElement(step, { next, completeForm, goTo })}</Form>
        </FormWrapper>
      </LS.Col>
    </>
  );
};

export default MultiStepForm;
